<template>
  <b-card>
    <b-row class="d-flex align-items-center">
      <b-col>
        <b-form-group
          label="Tarih Aralığı"
          label-for="dates"
        >
          <b-input-group id="dates">
            <b-form-datepicker
              v-model="filterParams.sdate"
              v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
            <b-input-group-append v-if="filterParams.sdate">
              <b-button
                variant="outline-warning"
                @click="clearDate('sdate')"
              >
                <FeatherIcon icon="XIcon" />
              </b-button>
            </b-input-group-append>
            <b-input-group-append is-text>
              -
            </b-input-group-append>
            <b-form-datepicker
              v-model="filterParams.edate"
              v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
            />
            <b-input-group-append v-if="filterParams.edate">
              <b-button
                variant="outline-warning"
                @click="clearDate('edate')"
              >
                <FeatherIcon icon="XIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Şube"
          label-for="id_branches"
        >
          <v-select
            id="id_branches"
            v-model="filterParams.id_branches"
            :options="branches"
            label="title"
            :reduce="item => item.id"
            placeholder="Seçiniz"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="auto"
      >
        <b-button
          variant="primary"
          @click="getFilteredData"
        >
          <FeatherIcon icon="FilterIcon" />
          Filtrele
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BFormDatepicker, BFormGroup, BInputGroup, BInputGroupAppend, BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterParams',
  components: {
    BFormGroup,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    BCard,
    BRow,
    BCol,
    BButton,
  },
  props: {
    getFilteredData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['reports/filterParams']
    },
    branches() {
      return this.$store.getters['branches/dataList']
    },
  },
  created() {
    this.getBranches()
  },
  methods: {
    clearDate(type) {
      if (type === 'sdate') {
        this.filterParams.sdate = null
      }
      if (type === 'edate') {
        this.filterParams.edate = null
      }
    },
    getBranches() {
      this.$store.dispatch('branches/getDataList', {
        select: [
          'branches.id AS id',
          'branches.title AS title',
        ],
      })
    },
  },
}
</script>
